import { render, staticRenderFns } from "./coffee-filter.vue?vue&type=template&id=2af642fa&scoped=true&"
import script from "./coffee-filter.vue?vue&type=script&lang=js&"
export * from "./coffee-filter.vue?vue&type=script&lang=js&"
import style0 from "./coffee-filter.vue?vue&type=style&index=0&id=2af642fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af642fa",
  null
  
)

export default component.exports